// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountGuide_container__21AN8","stampImage":"AccountGuide_stampImage__2YIpn","button":"AccountGuide_button__146LR","red":"AccountGuide_red__2lMBF"};